export  default {
  de: {
    mobile: 'Mobil',
    email: 'E-Mail',
    phone: 'Telefon'
  }
}
